import React, { useEffect } from "react";
import { Button } from "./styled";
import { Spinner, useThemeUI } from "theme-ui";

const BasicButton = ({ 
  children, 
  scheme = "primary", 
  styles,
  type = "button", 
  outline = false,
  disabled,
  $submitting, 
  $iconWidth,
  $iconHeight,
  $loadingColor,
  keepText = false,
  onClick, 
}: {
  children: any;
  scheme?: string;
  styles?: {[key: string] : {[key: string] : string} | string };
  outline?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;  
  $submitting?: boolean;
  $iconWidth?: string;
  $iconHeight?: string;
  $loadingColor?: string;
  keepText?: boolean;
  onClick?: (val?: any) => void;
}) => {
  const { theme } = useThemeUI();
  const variant = `${scheme}${outline ? "Outline" : ""}`
  const isVariantDefined = variant in (theme?.buttons || {});


  return (    
    <Button type={type || "button"} variant={isVariantDefined ? variant : "primary"} sx={styles} disabled={disabled || $submitting} onClick={onClick} $iconWidth={$iconWidth} $iconHeight={$iconHeight}>
      {!$submitting && children}
      {$submitting && <><Spinner size={14} sx={{color: $loadingColor, marginRight: keepText ? "10px" : "0px"}}/> { keepText ? children : ''}</>}
    </Button>    
  );
};

export default BasicButton;